(function (){
    angular.module('tmx-app').provider("routes", ["$stateProvider",

        function routes($stateProvider) {
            var routeManager=this;
            routeManager.routes=[];
            routeManager.returnObject=new returnObject(routeManager.routes);

            routeManager.createRoutes=function(states){
                for(var i=0;i<states.length;i++){
                    var s=states[i];
                    routeManager.routes.push(new route(s.state,s.hasCtrl,s.isAbstract,s.resolve));
                }
            }

            routeManager.createCrudRoutes=function(crudStates){
                for(var i=0;i<crudStates.length;i++){
                    var listState=crudStates[i].state;
                    var addState=listState+".Add";
                    var editState=listState+".Edit";
                    var listRoute=new route(listState,true,false,crudStates[i].listResolve);
                    var addRoute=new route(addState,true,false,crudStates[i].addResolve);
                    var editRoute=new route(editState,true,false,crudStates[i].editResolve);
				
                    editRoute.controller=getController(listRoute.name+editRoute.name);
                    editRoute.controllerAs=getControllerAs(listRoute.name+editRoute.name);	  

                    addRoute.controller=getController(listRoute.name+addRoute.name);
                    addRoute.controllerAs=getControllerAs(listRoute.name+addRoute.name);	  
					
                    if(!crudStates[i].differentAddEditViews) {

                        addRoute.templateUrl=editRoute.templateUrl;
                        addRoute.controller=editRoute.controller;
                        addRoute.controllerAs=editRoute.controllerAs;
							
                    }
					// addRoute.url+="/:Id";
					
					// addRoute.url+="/:Id";
                    editRoute.url+="/:Id";
                    routeManager.routes.push(listRoute);
                    routeManager.routes.push(addRoute);
                    routeManager.routes.push(editRoute);
                    if(angular.isDefined(crudStates[i].infoResolve)){
                        var infoState=listState+".Info";
                        var infoRoute=new route(infoState,true,false,crudStates[i].infoResolve);
                        infoRoute.templateUrl=editRoute.templateUrl;
                        infoRoute.controller=editRoute.controller;
                        infoRoute.controllerAs=editRoute.controllerAs;
                        infoRoute.url+="/:Id";
                        routeManager.routes.push(infoRoute);

                    }

                }
            }

            routeManager.registerRoutes=function(){
                for(var i=0;i<routeManager.routes.length;i++){
                    $stateProvider.state(routeManager.routes[i].state,routeManager.routes[i].toStateObj());
                }
            }

            routeManager.setUrl=function(stateIndex,url){
                routeManager.routes[stateIndex].url=url;
            }
            routeManager.appendUrl=function(stateIndex,url){
                routeManager.routes[stateIndex].url+=url;
            }
            this.$get = [function () {
                return new returnObject(routeManager.routes);
            }];
        }]);

    var returnObject=function(routes){
        var obj=this;
        obj.routes=routes;

        obj.getRouteByName=function(name){	 
            name=name.toLowerCase();
            for(var i=0;i<obj.routes.length;i++){
                if(obj.routes[i].name.toLowerCase()===name)return obj.routes[i];
            }
            return null;
        }

        obj.getRouteByState=function(state){
            state=state.toLowerCase();
            for(var i=0;i<obj.routes.length;i++){
                if(obj.routes[i].state.toLowerCase()===state)return obj.routes[i];
            }
            return null;
        }
    }

    var route=function(_state,_enableController,_abstract,_resolve) {
        var r=this;
        r.state=regularize(_state);
        r.name=getName(_state);
        r.url=getUrl(r.name);
        if(angular.isDefined(_enableController)&&_enableController){
            r.controller=getController(r.name);
            r.controllerAs=getControllerAs(r.name);  
        }
        if(angular.isDefined(_abstract))
            r.abstract= _abstract;
        else
            r.abstract=false;
        r.templateUrl=getTemplateUrl(_state);
        if(angular.isDefined(_resolve)){
            r.resolve={
                resolvedData:_resolve
            };
        }

        r.toStateObj=function(){
            var result={
                url:r.url,
                templateUrl:r.templateUrl
            };
            if(angular.isDefined(r.controller)){
                result.controller=r.controller;
                result.controllerAs=r.controllerAs;
            }
            if(angular.isDefined(r.abstract)){
                result.abstract=r.abstract;
            }
            if(angular.isDefined(r.resolve)){
                result.resolve=r.resolve;
            }
            return result;
        };
    }


    function removeSpace(value){
        return (!value) ? '' : value.replace(/ /g, '');
    }

    function regularize(name){
        return removeSpace(name).toLowerCase();
    }

    function toFileName(name){
        var arr=name.split(/(?=[A-Z])/); 
        var fileName='';
        for(var i=0;i<arr.length;i++){
            fileName+=regularize(arr[i])+'-';
        }
        return fileName.substring(0, fileName.length - 1);
    }

    function getName(state){
        var arr=state.split(".");
        return arr[arr.length-1];
    }

    function getUrl(name){    
        return '/'+regularize(name);
    }

    function getController(name){
        var ctrlName= name+'Ctrl';
        ctrlName=ctrlName[0].toLowerCase()+ctrlName.substring(1);
        return ctrlName;
    }

    function getControllerAs(name){
        var ctrlName= name+'Ctrl';
        return ctrlName;
    }

    function getTemplateUrl(state){
        var arr=state.split(".");
        var tmplUrl='app';
        for(var i=0;i<arr.length;i++){
            tmplUrl+='/'+toFileName(arr[i]);
        }
        tmplUrl+='/'+toFileName(arr[arr.length-1])+'.html';
        return tmplUrl;
    }

})();